var map = {
	"./arredo quattro.jpg": 134,
	"./bosch.png": 135,
	"./calligaris.png": 136,
	"./cantiero.png": 137,
	"./colombini.png": 138,
	"./creo kitchens.png": 139,
	"./dall'agnese.png": 140,
	"./della rovere.png": 141,
	"./dorelan.png": 142,
	"./edmo.png": 143,
	"./electrolux.png": 144,
	"./franke.png": 145,
	"./lube.png": 146,
	"./moretti.png": 147,
	"./okite.png": 148,
	"./samoa.png": 149,
	"./target.png": 150,
	"./tommasella.png": 151,
	"./zamagna.png": 152
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 133;